import React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPermissions } from "../redux/permissionsSlice";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary, 
}));

const Complaints = () => {
  const names = ["Ticket Generation", "Escalation", "Closer"];

  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      (permission) => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission("Ticket Generation") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link="#"
                // link={{ pathname: '/' }}
                permissions={permissions}
                title="Ticket Generation"
              />
            )}
            {/* {hasModulePermission("Service/Complaint") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              // link="#"
              link={{ pathname: '/tkt-dashboard' }}
              permissions={permissions}
              title="Ticket Dashboard"
            />)} */}
            {hasModulePermission("Ticket Dashboard") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: "/raise-tkt-dashboard" }}
                permissions={permissions}
                title="Ticket Dashboard"
              />
            )}
            {hasModulePermission("Raise Service Ticket") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: "/raise-service-tkt" }}
                permissions={permissions}
                title="Raise Service Ticket"
              />
            )}

            {hasModulePermission("Task Assignment") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: "/task-assignment" }}
                permissions={permissions}
                title="Task Assignment"
              />
            )}
             {hasModulePermission("Task Acceptance") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: "/task-acceptance" }}
                permissions={permissions}
                title="Task Acceptance"
              />
            )}

             {hasModulePermission("Task Status") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: "/task-status" }}
                permissions={permissions}
                title="Task Status"
              />
            )}
            {/* {hasModulePermission("Closer") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link="#"
                // link={{ pathname: '/' }}
                permissions={permissions}
                title="Closer"
              />
            )}  */}
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}></Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Complaints;
